import { rem as polishedRem } from 'polished';
// 1.6rem === 16px
const remSizeInPx = 15;
export const pxToRem = (pxValue) => polishedRem(pxValue, remSizeInPx);
